/* eslint-disable camelcase */

import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import Rating from 'components/rating';
import t from 'translations';
import getProductPrice from 'util/misc/get-product-price';
import formatPrice from 'util/misc/format-price';
import formatProductShortDescription from 'util/react/format-product-short-description';
import { imageByDpi, productImage } from '../../util/react/stack-images-path';
import { BADGE_DETAIL } from 'constants/api-images-types';

function Price({ price_information }) {
    const realPrice = getProductPrice(price_information);
    const hasBadge = !isNil(price_information.badge);
    const hasDiscount = !isNil(price_information.original_price);

    if (hasBadge) {
        return (
            <div className="product-info-card--discount" itemProp="offers" itemScope itemType="http://schema.org/Offer">
                <div className="product-info-card--price">
                    <meta itemProp="priceCurrency" content="CHF"/>
                    <span itemProp="price">{formatPrice(realPrice)}</span>
                </div>
                {hasDiscount && <div className="product-info-card--old-price">
                    {t('products.instead_of')} {formatPrice(price_information.original_price)}
                </div>}
            </div>
        );
    }

    return (
        <div className="product-info-card--price" itemProp="offers" itemScope itemType="http://schema.org/Offer">
            <meta itemProp="priceCurrency" content="CHF"/>
            <span itemProp="price">{formatPrice(realPrice)}</span>
        </div>
    );
}

Price.propTypes = {
    short_description: PropTypes.array,
    price_information: PropTypes.object.isRequired,
};

export default function ProductInfoCard({ name, price_information, ratings, slug, short_description }) {
    return (
        <article className="product-info-card">
            <div className="product-info-card--price-info">
                {price_information.badge ?
                    <img className="product-info-card--badge"
                        src={imageByDpi(productImage(price_information.badge, BADGE_DETAIL))}/> : null}
                <Price price_information={price_information}/>
            </div>
            <h1 className="product-info-card--title u-reset" itemProp="name">
                {name}
            </h1>
            {short_description &&
            <p className="product-info-card--paragraph">{formatProductShortDescription(short_description)}</p>}
            {ratings.average_all ? <Rating isEditing={false} value={ratings.average_all} reviews={ratings.count_all}
                name={slug || name}/> : ''}
        </article>
    );
}

ProductInfoCard.propTypes = {
    short_description: PropTypes.array,
    name: PropTypes.string.isRequired,
    price_information: PropTypes.object.isRequired,
    ratings: PropTypes.object,
    slug: PropTypes.string,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-info-card/index.js